import React from "react";
import { ConfigProvider, DatePicker as AntdDatePicker } from "antd";
import ptBR from "antd/locale/pt_BR";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import 'dayjs/locale/es';    // Spanish

dayjs.locale("pt-br");

export function DateToString(params) {
  try {
    if (params.displayTime == true) {
      return params.date?.isValid?.() ? params.date.format("DD/MM/YYYY HH:mm:ss") : "";
    }
    else {
      return params.date?.isValid?.() ? params.date.format("DD/MM/YYYY") : "";
    }
  }
  catch (e) {
    console.warn("Failed to convert date", e);
    return "";
  }
}
export function DisplayGridDatetime(params) {
  const isoString = params.value;
  if (!isoString) {
    return '';
  }
  const dateObj = dayjs(isoString);
  if (!dateObj.isValid()) {
    return '';
  }
  return dateObj.format("DD/MM/YYYY HH:mm:ss");
}
export function DateToIsoString(fromDate) {
  try {
    return fromDate?.isValid?.() ? fromDate.format("YYYY-MM-DD HH:mm:ss") : "";
  } catch (e) {
    console.warn("Failed to convert date", e);
    return "";
  }
}
export function DateFromIsoString(isoString) {
  try {
    return isoString ? dayjs(isoString) : dayjs();
  } catch (e) {
    console.warn("Failed to parse date", e);
    return dayjs();
  }
}
export function InitDateToIsoString(fromDate) {
  try {
    return fromDate?.isValid?.() ? fromDate.format("YYYY-MM-DD HH:mm:ss") : "";
  } catch (e) {
    console.warn("Failed to convert date", e);
    return "";
  }
}
export function InitDateFromIsoString(isoString) {
  try {
    const baseDate = isoString ? dayjs(isoString).set('hour', 0).set('minute', 0).set('second', 0) : dayjs();
    return baseDate;
  } catch (e) {
    console.warn("Failed to parse date", e);
  }
}
export function FinDateToIsoString(fromDate) {
  try {
    return fromDate?.isValid?.() ? fromDate.format("YYYY-MM-DD HH:mm:ss") : "";
  } catch (e) {
    console.warn("Failed to convert date", e);
    return "";
  }
}
export function FinDateFromIsoString(isoString) {
  try {
    const baseDate = isoString ? dayjs(isoString).set('hour', 23).set('minute', 59).set('second', 59) : dayjs();
    return baseDate;
  } catch (e) {
    console.warn("Failed to parse date", e);
  }
}
export function setDefaultOrderInitDate(){
  return(dayjs().set('hour', 0).set('minute', 0).set('second', 0));
}
export function setDefaultInitDate(){
  return(dayjs().subtract(30 ,'day').set('hour', 0).set('minute', 0).set('second', 0));
}
export function setDefaultFinalDate(){
  return(dayjs().add(15,'day').set('hour', 23).set('minute', 59).set('second', 59));
}
export function compareInitFinDate(dt0, dt1) {
  return (dayjs(dt0) < dayjs(dt1)) ?  true : false;
}
export function getDateInEnglish() {
  const now = dayjs().locale('en');
  return {
    month: now.format('MMMM'),
    year: now.year()
  };
}
export function getDateInPortuguese() {
  const now = dayjs().locale('pt-br');
  return {
    month: now.format('MMMM'),
    year: now.year()
  };
}
export function getDateInSpanish() {
  const now = dayjs().locale('es');
  return {
    month: now.format('MMMM'),
    year: now.year()
  };
}
export const DatePicker = ({ value, onChange: onChangeProp, ...props }) => {
  const handleChange = (date) => {
    if (onChangeProp) {
      if (date === null) {
        onChangeProp(dayjs());
      }
      else {
        onChangeProp(date);
      }
    }
  };

  const handleFormatTyping = (e) => {
    let v = e.target.value.replace(/\D/g, "").slice(0, 7);
  
    if (v.length >= 5) {
      v = `${v.slice(0, 2)}/${v.slice(2, 4)}/${v.slice(4)}`;
    } else if (v.length >= 3) {
      v = `${v.slice(0, 2)}/${v.slice(2)}`;
    }
  
    e.target.value = v;
  }
  return (
    <ConfigProvider locale={ptBR}>
      <AntdDatePicker
        {...props}
        format="DD/MM/YYYY"
        value={value} // now strictly a dayjs object
        onChange={handleChange}
        onKeyDown={handleFormatTyping}
        allowClear
      />
    </ConfigProvider>
  );
};
export const DateTimePicker = ({ value, onChange: onChangeProp, ...props }) => {
  const handleChange = (date) => {
    if (onChangeProp) {
      if (date === null) {
        onChangeProp(dayjs());
      }
      else {
        onChangeProp(date);
      }
    }
  };
  const handleFormatTyping = (e) => {
    let v = e.target.value.replace(/\D/g, "").slice(0, 14); // 8 day + 6 hour
    v = v.replace(":", "");
    v = v.replace(" ", "");
  
    if (v.length >= 13) {
      v = `${v.slice(0, 2)}/${v.slice(2, 4)}/${v.slice(4, 8)} ${v.slice(8, 10)}:${v.slice(10, 12)}:${v.slice(12, 13)}`;
    } 
    else if (v.length >= 11) {
      v = `${v.slice(0, 2)}/${v.slice(2, 4)}/${v.slice(4, 8)}  ${v.slice(8, 10)}:${v.slice(10, 12)}`;
    } 
    else if (v.length >= 9) {
      v = `${v.slice(0, 2)}/${v.slice(2, 4)}/${v.slice(4, 8)}  ${v.slice(8, 10)}`;
    } 
    else if (v.length >= 5) {
      v = `${v.slice(0, 2)}/${v.slice(2, 4)}/${v.slice(4, 8)}`;
    } 
    else if (v.length >= 3) {
      v = `${v.slice(0, 2)}/${v.slice(2)}`;
    }
  
    e.target.value = v;
  };

  return (
    <ConfigProvider locale={ptBR}>
      <AntdDatePicker
        {...props}
        showTime={{ format: "HH:mm:ss" }}
        format="DD/MM/YYYY HH:mm:ss"
        value={value} // now strictly a dayjs object
        onChange={handleChange}
        onKeyDown={handleFormatTyping}
        allowClear
      />
    </ConfigProvider>
  );
};